import React from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';

import Button from '../Button';

import BannerHero from '../../assets/smart_banner_hero.png';
import {isMobileDevice} from '../../helpers';

const Container = styled.div`
    position: initial;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 56px;
    max-height: 56px;
    background: rgb(241, 239, 241);
    z-index: 105;
    padding: 0px 25px;
    box-sizing: border-box;

    & > button {
        font-size: 12px;
        height: 32px;
        width: 84px;
        min-width: 84px;
        line-height: 1;
        padding: 0px;

        span {
            color: #fff;
            font-family: 'TTNormsProExtraBlack';
            font-size: 12px;
            line-height: 1;
            text-transform: uppercase;
        }
    }
`;

const Hero = styled.img.attrs(props => ({
    src: BannerHero,
}))`
    object-fit: contain;
    width: 34px;
    height: 34px;
    margin-right: 16px;
    border-radius: 6px;
`;

const Text = styled.p`
    color: #000;
    margin: auto auto auto 0;
    font-family: 'AvenirNextRoundedStd';
    font-size: 14px;
    font-weight: normal;
    line-height: 18px;
`;

const SmartBanner = () => {
    const {t} = useTranslation();

    const handleRedirectAppStore = () => {
        window.turner_metadata.trackAction.push({
            type: 'interaction',
            data: {
                interaction: 'cnplus|download prompt',
                domain: 'cnplus.com',
                brand: 'cartoon network',
                interactionevent: 1,
            },
        });

        window.open('https://cnapp.page.link/85Up', '_blank');
    };

    return isMobileDevice() ? (
        <Container className="smart-banner">
            <Hero width="99px" height="58px" />
            <Text> {t('smartBanner.text')} </Text>
            <Button onClick={handleRedirectAppStore} margin="auto 0 auto 12px">
                <span> {t('smartBanner.cta')} </span>{' '}
            </Button>{' '}
        </Container>
    ) : null;
};

export default SmartBanner;
